import React, { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import BasicTable from "../../components/UiComponent/customTable.jsx";
import {
  get_ekyc_lists,
  RegisterEKYC,
  UpdateEKYC,
} from "../../services/projectApi.js";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { GetUserInfo } from "../../utils/permissionChecker.js";
import { toast } from "react-toastify";
import {
  Modal,
  Row,
  Form,
  Col,
  Button,
  Spinner,
  Nav,
  Tab,
} from "react-bootstrap";
import { formatDate } from "../../utils/date_utils.js";
import BATarget from "./BA_target.js";
import TaskTarget from "./task_target.js";
const BranchTargetConfig = () => {
  const { t } = useTranslation();
  const user = GetUserInfo();
  const currentUser =
    user.employee.first_name + " " + user.employee.father_name;
  const branch = user?.employee?.branch_id;
  return (
    <>
      <Tab.Container defaultActiveKey="home-tab">
        <Nav variant="tabs">
          <Nav.Item>
            <Nav.Link eventKey="home-tab">BA Target </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="profile-tab">Task Target</Nav.Link>
          </Nav.Item>
          {/* <Nav.Item>
            <Nav.Link eventKey="contact-tab">Contact</Nav.Link>
          </Nav.Item> */}
        </Nav>
        <Tab.Content>
          <Tab.Pane eventKey="home-tab">
            <BATarget />
          </Tab.Pane>
          <Tab.Pane eventKey="profile-tab">
            <TaskTarget />
          </Tab.Pane>
          <Tab.Pane eventKey="contact-tab">
            <p>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since the 1500s, when an unknown printer took a galley of
              type and scrambled it to make a type specimen book.
            </p>
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </>
  );
};

export default BranchTargetConfig;
